import React from "react";
import { Link } from "react-router-dom";

const Section = ({ name, url, icon: Icon }) => {
  return (
    <Link
      to={url}
      className="flex items-center justify-start px-4 py-3 border border-green-500 rounded-lg shadow-sm hover:shadow-md transition-shadow duration-300 ease-in-out hover:bg-green-50"
    >
      {/* Ícone */}
      {Icon && (
        <div className="mr-3 text-green-500 text-2xl">
          <Icon />
        </div>
      )}

      {/* Texto */}
      <span className="text-gray-800 font-semibold">{name}</span>
    </Link>
  );
};

export default Section;
